// @flow
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './Footer.styles';

type Props = {
  classes: any
};

class Footer extends React.Component<Props> {
  render() {
    const classes = this.props.classes;

    // eslint-disable-next-line
    const footerLink = <a href="http://aryafa.com/"target="_blank">طراحی و اجرا توسط آریافا</a>;

    return (
      <footer className={classes.footer}>
        تمامی حقوق محفوظ است.<br/>
        {footerLink}
        <br/>نسخه بتا
      </footer>
    );
  }
}

const Component = withStyles(styles)(Footer);
export {Component as Footer};